
import DragUpload from '@/components/util/DragUpload.vue';
import List from '@/components/util/List.vue';
import StatusStepper from '@/components/orders/StatusStepperComponent.vue';
import DetailLayout from '@/components/system/DetailsLayout.vue';
import Location2DisplayComponent from '@/components/system/Location2DisplayComponent.vue';
import DocumentList from '@/components/documents/DocumentListView.vue';

import { Component, Prop, Vue } from 'vue-property-decorator';

import { Property, Workorder } from 'performo-api';

import { mapGetters } from 'vuex';

@Component({
  components: {
    List,
    StatusStepper,
    DragUpload,
    DetailLayout,
    Location2DisplayComponent,
    DocumentList
  },
  computed: mapGetters({
    currentProperty: 'currentProperty'
  })
})
export default class RequesterDetail extends Vue {
  private survey = { message: '', rating: 0 };
  private commentText = '';

  private currentProperty!: Property;

  get photoSource() {
    if (!this.photo) return null;
    if (this.photo.size <= 0) return null;
    return window.URL.createObjectURL(this.photo);
  }

  get orderNotesDisplay() {
    if (!this.order.notes) return '';
    return this.order.notes.replace(/(?:\r\n|\r|\n)/g, '<br>');
  }
  get showSubmitSurvey() {
    return this.survey.rating !== 0;
  }

  private addCommentIfEnter(sender: KeyboardEvent) {
    if (sender.keyCode === 13) {
      // clear
      this.addComment();
    }
  }

  private addComment() {
    this.$emit('commentAdded', this.commentText, 'public');
    this.commentText = '';
  }

  get currentPropertyId(): string {
    return this.$store.getters.currentPropertyId;
  }

  private successHandler(data: Workorder) {
    if (this.refresh) {
      this.refresh(data);
    }
  }

  private errorHandler(error: string | Error) {
    console.log(error);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private successDocUploadHandler(data: Document) {
    if (this.refresh) {
      this.refresh();
    }
  }

  private errorDocUploadHandler(error: string | Error) {
    console.log(error);
  }

  @Prop({ required: true })
  private order!: Workorder;

  @Prop() private photo!: Blob;

  @Prop({ required: false, type: Function })
  private refresh!: (response?: Workorder) => Promise<void>;
}
